<template>
  <nav>
    <router-link to="/" exact>
      <q-btn icon="fa fa-home" flat stretch />
    </router-link>
    <q-separator vertical />
    <router-link :to="`/clients/${clientId}/albums`" exact>
      <q-btn
        icon="fa fa-address-book"
        label="Digital Albums"
        stretch
        flat
        no-caps
      />
    </router-link>
    <router-link :to="`/clients/${clientId}/posts`" exact>
      <q-btn
        icon="fa fa-images"
        label="Social Posts"
        stretch
        flat
        no-caps
      />
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@import '../styles/quasar.variables.scss';

nav {

  @media screen and (min-width: $breakpoint-sm-max) {
    display: flex;
    align-self: stretch;
    align-items: stretch;

    a {
      display: flex;
      align-items: center;
      color: $grey-9;
      button {
        text-align: center;
        padding: 0 1rem;
      }
    }
  }

  a {
    display: block;
    color: $grey-8;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import recognition from '../auth/recognition';

export default defineComponent({
  computed: {
    isClient(): boolean {
      return recognition.isClient();
    },
    clientId(): number|null {
      return recognition.isClient() ? recognition.getAccountId() : null;
    },
  },
});
</script>
